export default __webpack_public_path__ + "static/media/117-meditate-clear-sky.a19cdf36.jpeg";